<template>
  <div>
    <section class="section-padding bg-white">
      <div class="container-width max-w-4xl">
        <h1 class="text-dark-900 mb-8">Datenschutzerklärung</h1>

        <div class="space-y-8 text-dark-700">
          <!-- 1. Datenschutz auf einen Blick -->
          <div>
            <h2 class="text-2xl font-bold text-dark-900 mb-4">1. Datenschutz auf einen Blick</h2>

            <h3 class="text-xl font-semibold text-dark-900 mb-3 mt-6">Allgemeine Hinweise</h3>
            <p class="leading-relaxed mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3 mt-6">Datenerfassung auf dieser Website</h3>
            <p class="font-semibold mb-2">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</p>
            <p class="leading-relaxed mb-4">
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
            </p>

            <p class="font-semibold mb-2">Wie erfassen wir Ihre Daten?</p>
            <p class="leading-relaxed mb-4">
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
            </p>

            <p class="font-semibold mb-2">Wofür nutzen wir Ihre Daten?</p>
            <p class="leading-relaxed mb-4">
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Sofern über die Website Verträge geschlossen oder angebahnt werden können, werden die übermittelten Daten auch für Vertragsangebote, Bestellungen oder sonstige Auftragsanfragen verarbeitet.
            </p>

            <p class="font-semibold mb-2">Welche Rechte haben Sie bezüglich Ihrer Daten?</p>
            <p class="leading-relaxed">
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>
          </div>

          <!-- 2. Hosting -->
          <div class="border-t border-gray-200 pt-8">
            <h2 class="text-2xl font-bold text-dark-900 mb-4">2. Hosting</h2>
            <p class="leading-relaxed mb-4">
              Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3">All-Inkl</h3>
            <p class="leading-relaxed mb-4">
              Anbieter ist die ALL-INKL.COM - Neue Medien Münnich, Inh. René Münnich, Hauptstraße 68, 02742 Friedersdorf (nachfolgend All-Inkl). Wenn Sie unsere Website besuchen, erfasst All-Inkl verschiedene Logfiles inklusive Ihrer IP-Adressen.
            </p>
            <p class="leading-relaxed mb-4">
              Weitere Informationen entnehmen Sie der Datenschutzerklärung von All-Inkl:
              <a href="https://all-inkl.com/datenschutzinformationen/" target="_blank" rel="noopener noreferrer" class="text-primary-500 hover:text-primary-600 underline">
                https://all-inkl.com/datenschutzinformationen/
              </a>
            </p>
            <p class="leading-relaxed">
              Die Verwendung von All-Inkl erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TTDSG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z.B. Device-Fingerprinting) im Sinne des TTDSG umfasst.
            </p>
          </div>

          <!-- 3. Allgemeine Hinweise und Pflichtinformationen -->
          <div class="border-t border-gray-200 pt-8">
            <h2 class="text-2xl font-bold text-dark-900 mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>

            <h3 class="text-xl font-semibold text-dark-900 mb-3">Datenschutz</h3>
            <p class="leading-relaxed mb-4">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
            <p class="leading-relaxed mb-4">
              Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3 mt-6">Hinweis zur verantwortlichen Stelle</h3>
            <p class="leading-relaxed mb-4">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p class="leading-relaxed mb-4">
              Enrico Reinsdorf<br>
              Züricher Str. 52<br>
              90431 Nürnberg<br><br>
              E-Mail: <a href="mailto:enrico.reinsdorf@re-design.de" class="text-primary-500 hover:text-primary-600">enrico.reinsdorf@re-design.de</a>
            </p>
            <p class="leading-relaxed">
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3 mt-6">Speicherdauer</h3>
            <p class="leading-relaxed">
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben (z.B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3 mt-6">SSL- bzw. TLS-Verschlüsselung</h3>
            <p class="leading-relaxed">
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
          </div>

          <!-- 4. Datenerfassung auf dieser Website -->
          <div class="border-t border-gray-200 pt-8">
            <h2 class="text-2xl font-bold text-dark-900 mb-4">4. Datenerfassung auf dieser Website</h2>

            <h3 class="text-xl font-semibold text-dark-900 mb-3">Server-Log-Dateien</h3>
            <p class="leading-relaxed mb-4">
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
            </p>
            <ul class="list-disc list-inside space-y-2 mb-4">
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p class="leading-relaxed mb-4">
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3 mt-6">Cookies und Einwilligungsmanagement</h3>
            <p class="leading-relaxed mb-4">
              Unsere Website verwendet ein Einwilligungs-Management für optionale Kategorien (Funktionalität, Analytik). Die technische Speicherung Ihrer Auswahl erfolgt lokal in Ihrem Browser im Local Storage unter dem Eintrag "cookieConsent".
            </p>
            <p class="leading-relaxed mb-4">
              Dabei werden insbesondere der Status Ihrer Auswahl (notwendig/funktional/analytisch), ein Zeitstempel und eine Versionskennung der Einwilligung gespeichert. Notwendige technische Funktionen bleiben davon unberührt.
            </p>
            <p class="leading-relaxed mb-4">
              Rechtsgrundlage für optionale Kategorien ist Art. 6 Abs. 1 lit. a DSGVO in Verbindung mit § 25 Abs. 1 TTDSG (Einwilligung). Rechtsgrundlage für notwendige technische Speicherung ist Art. 6 Abs. 1 lit. f DSGVO in Verbindung mit § 25 Abs. 2 TTDSG.
            </p>
            <p class="leading-relaxed mb-4">
              Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft über die Cookie-Einstellungen ändern oder widerrufen.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3 mt-6">Kontaktformular</h3>
            <p class="leading-relaxed mb-4">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, verarbeiten wir die von Ihnen eingegebenen Angaben (Name, E-Mail-Adresse, Betreff, Nachricht) sowie technische Sicherheitsdaten (Zeitstempel, Anti-Spam-Feld/Honeypot und Signatur zur Integritätsprüfung).
            </p>
            <p class="leading-relaxed mb-4">
              Die Übermittlung erfolgt per HTTPS an einen n8n-Webhook zur Bearbeitung Ihrer Anfrage. Die technische Verarbeitung erfolgt über unsere n8n-Instanz bei Hostinger (Serverstandort Deutschland).
            </p>
            <p class="leading-relaxed mb-4">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven und sicheren Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), sofern diese abgefragt wurde.
            </p>
            <p class="leading-relaxed mb-4">
              Speicherdauer: Die über das Kontaktformular übermittelten Daten werden bis zur finalen Bearbeitung Ihrer Anfrage gespeichert und anschließend gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3 mt-6">Cloudflare Turnstile (Spam-Schutz)</h3>
            <p class="leading-relaxed mb-4">
              Im Bereich des Kontaktformulars kann zur Spam-Abwehr Cloudflare Turnstile eingesetzt werden. Ob Turnstile zu einem konkreten Zeitpunkt aktiv ist, hängt von der jeweils produktiven Formular-Konfiguration ab.
            </p>
            <p class="leading-relaxed mb-4">
              Sofern Turnstile aktiv ist, können technische Verbindungsdaten (z.B. IP-Adresse, Browser- und Gerätedaten, Zeitstempel) an Cloudflare übermittelt werden.
            </p>
            <p class="leading-relaxed mb-4">
              Anbieter: Cloudflare, Inc., 101 Townsend St., San Francisco, CA 94107, USA. Weitere Informationen:
              <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer" class="text-primary-500 hover:text-primary-600 underline">
                https://www.cloudflare.com/privacypolicy/
              </a>
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3 mt-6">Auftragsverarbeitung (n8n / Hostinger)</h3>
            <p class="leading-relaxed mb-4">
              Für die technische Verarbeitung von Kontaktanfragen nutzen wir n8n als Automatisierungsdienst auf einer von uns betriebenen Instanz bei Hostinger. Hostinger wird dabei als Auftragsverarbeiter eingesetzt.
            </p>
            <p class="leading-relaxed mb-4">
              Die Verarbeitung erfolgt auf Servern in Deutschland und ausschließlich zweckgebunden zur Bearbeitung Ihrer Anfrage.
            </p>

          </div>

          <!-- 5. Ihre Rechte -->
          <div class="border-t border-gray-200 pt-8">
            <h2 class="text-2xl font-bold text-dark-900 mb-4">5. Rechte der betroffenen Person</h2>

            <p class="leading-relaxed mb-4">
              Sie haben nach der DSGVO verschiedene Rechte bezüglich Ihrer personenbezogenen Daten:
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3">Auskunftsrecht (Art. 15 DSGVO)</h3>
            <p class="leading-relaxed mb-4">
              Sie haben das Recht, jederzeit von uns unentgeltliche Auskunft über die zu Ihrer Person gespeicherten personenbezogenen Daten sowie eine Kopie dieser Daten nach Maßgabe der gesetzlichen Bestimmungen zu erhalten.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3">Recht auf Berichtigung (Art. 16 DSGVO)</h3>
            <p class="leading-relaxed mb-4">
              Sie haben das Recht, die Berichtigung Sie betreffender unrichtiger personenbezogener Daten zu verlangen.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3">Recht auf Löschung (Art. 17 DSGVO)</h3>
            <p class="leading-relaxed mb-4">
              Sie haben das Recht, die unverzügliche Löschung Sie betreffender personenbezogener Daten zu verlangen, sofern einer der gesetzlich vorgesehenen Gründe vorliegt und soweit die Verarbeitung nicht erforderlich ist.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3">Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</h3>
            <p class="leading-relaxed mb-4">
              Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen, sofern einer der gesetzlich vorgesehenen Gründe vorliegt.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3">Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</h3>
            <p class="leading-relaxed mb-4">
              Sie haben das Recht, die Sie betreffenden personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3">Widerspruchsrecht (Art. 21 DSGVO)</h3>
            <p class="leading-relaxed mb-4">
              Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen.
            </p>

            <h3 class="text-xl font-semibold text-dark-900 mb-3">Beschwerderecht bei der Aufsichtsbehörde</h3>
            <p class="leading-relaxed">
              Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren. Die für uns zuständige Aufsichtsbehörde ist das Bayerische Landesamt für Datenschutzaufsicht (BayLDA).
            </p>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
useHead({
  title: 'Datenschutz',
  meta: [
    { name: 'robots', content: 'noindex, nofollow' }
  ]
})
</script>
